import {v4 as uuid} from 'uuid';
import {
  downloadFlow,
  extractFilenameFromContentDisposition,
} from '@contentlab/utils/downloadFlow';
import contentStudioInstance from '@/utils/axiosContentStudio';

async function downloadProject(
  projectId: string,
  analyticsInteractionID: string,
  analyticsLocation: string,
  processEventHandlers: {
    started: (params: any) => void;
    ended: (params: any) => void;
  }
) {
  const {started, ended} = processEventHandlers;
  const processID = uuid();

  const endpoint = `/api/v1/projects/${projectId}/download-output`;
  started({
    endpoint,
    process_id: processID,
    process_name: 'download',
    original_id: projectId,
    interaction_id: analyticsInteractionID,
    asset_id: projectId,
    source: analyticsLocation,
  });

  let result = '';
  let errorMessage = '';

  try {
    const response = await contentStudioInstance.get(endpoint, {
      responseType: 'blob',
    });

    const filename = extractFilenameFromContentDisposition(response, 'assets');
    downloadFlow(response, filename);
    result = 'success';
    errorMessage = '';
  } catch (err) {
    result = 'failure';
    errorMessage = err instanceof Error ? err.message : String(err);
  } finally {
    ended({
      endpoint,
      outcome_id: projectId,
      original_id: projectId,
      result,
      process_id: processID,
      process_name: 'download',
      error: errorMessage,
    });
  }
}

export default downloadProject;
